import React, { Component } from "react";
import PropTypes from "prop-types";

import "./LoginDescriptionRow.css";

const propTypes = {
  projectDescription: PropTypes.string
};

class LoginDescriptionRow extends Component {
  render() {
    return (
      <div className="innerblock pure-g">
        <div className="pure-u-1-1">
          <p className="gourmet-grammar-project-description bottommargin-30">
            {this.props.projectDescription}
          </p>
        </div>
      </div>
    );
  }
}

LoginDescriptionRow.propTypes = propTypes;

export default LoginDescriptionRow;
